<template>
  <div>
    <g-master name="trabajos"
              :endpoint="lvlComMaster.endpoint"
              :tableSetup="lvlComMaster.tableSetup"
              :modalFieldsSetup="lvlComMaster.modalFieldsSetup"
              :parentData="parentData"
              ref="lvlComMaster"
              :beforeSend="lvlComMaster.beforeSend"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <g-dropdown :label="$t('Cargo')"
                        :selectConfig="{mode:'multiple'}"
                        :formItemConfig="fiOptions"
                        endpoint="jobs"
                        :decorator="['id_job', { rules: [{ required: true, message: 'Valor requerido' }] }]">
            </g-dropdown>
          </a-col>
        </a-row>
      </template>
    </g-master>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        visible: false,
        nombre: '',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        lvlComMaster: {
          beforeSend: (data) => {
            data.id_objectives = this.id_level
            return data
          },
          endpoint: 'position_objectives',
          tableSetup: {
            actions: {
              title: 'Acciones',
              scopedSlots: {customRender: 'hooverableAction'},
              width: 90,
              fixed: 'right',
              actions: [
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Nombre', dataIndex: 'job_name', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_job'}
          ]
        }
      }
    },
    props: ['id_level'],
    computed: {
      parentData () {
        return {
          id_objectives: this.id_level
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/ObjectivesPosition.vue